export enum StepNames {
  PersonalIdentification = 'step-personal-identification',
  PersonalInformation = 'step-personal-information',
  AccountInformation = 'step-account-information',
  AccountValidationType = 'step-account-validation-type',
  UploadDocuments = 'step-upload-documents'
}

export enum UPLOAD_RULE_STAGE {
  ACCOUNT_CREATION = 'C'
}

export enum CUSTOM_MESSAGE_ACTION {
  UPLOAD_ACCOUNT_CREATION = 'UC'
}
